var account = "https://shopfront-cdn.tekoapis.com/static/360d583357852b95.svg";

export { account as default };
